import { render, staticRenderFns } from "./orderTab.vue?vue&type=template&id=7182a762&scoped=true"
import script from "./orderTab.vue?vue&type=script&lang=js"
export * from "./orderTab.vue?vue&type=script&lang=js"
import style0 from "./orderTab.vue?vue&type=style&index=0&id=7182a762&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182a762",
  null
  
)

export default component.exports